import { EducationalInformationLoader } from './parts/EducationalInformationLoader';
import Header from './parts/Header';
import { MainStudies } from './parts/MainStudies/MainStudies';
import { OtherStudies } from './parts/OtherStudies/OtherStudies';
import { OtherStudiesLoader } from './parts/OtherStudies/OtherStudiesLoader';

export const EducationalInformation = () => {
  return (
    <>
      <EducationalInformationLoader>
        {({ postulant, mainStudies, studentId }) => (
          <>
            <Header postulant={postulant} />
            <MainStudies mainStudiesData={mainStudies} />

            <OtherStudiesLoader>
              {({
                otherStudies,
                otherStudiesPagination,
                query,
                updateQuery,
                refresh,
              }) => (
                <>
                  <OtherStudies
                    otherStudies={otherStudies}
                    paginationData={otherStudiesPagination}
                    query={query}
                    updateQuery={updateQuery}
                    refresh={refresh}
                  />
                </>
              )}
            </OtherStudiesLoader>
          </>
        )}
      </EducationalInformationLoader>
    </>
  );
};
